import { CoreInput } from '@/components/Form/InputAntForm';
import CoreSelect from '@/components/Form/SelectAntForm';
import { CoreSwitch } from '@/components/Form/Switch';
import { useCoreContext } from '@/core';
import { PropsWardForm } from '@/domains/wards/ports/payloads';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Input, Typography } from 'antd';
import { debounce, get } from 'lodash';
import { useEffect } from 'react';
import { Controller, FormProvider } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import useViewModel from '../../viewmodels/ward-form.viewmodel';

export const WardForm = (props: PropsWardForm) => {
  const { openForm, detailWard } = props;
  const { districtData } = useCoreContext();
  const { cityData, searchCity } = useCoreContext();

  const [currentQueryParameters] = useSearchParams();
  const showId = currentQueryParameters.get('id');
  const { methodForm, initialValue, onSubmit } = useViewModel(props);
  const {
    control,
    reset,
    formState: { isSubmitting, isDirty },
  } = methodForm;

  useEffect(() => {
    if (!showId) {
      reset(initialValue);
    }
  }, [openForm]);

  return (
    <FormProvider {...methodForm}>
      <form onSubmit={onSubmit}>
        <div className='w-full flex'>
          <div className='px-3 mb-6'>
            <Typography.Title level={4}>
              {showId ? get(detailWard, 'name') : 'Create'}
            </Typography.Title>
          </div>
          <div className='ml-auto'>
            <CoreSwitch
              control={control}
              name='isActive'
              className='px-3 mt-2'
              formatValue={true}
            />
          </div>
        </div>
        <div className='w-full flex flex-wrap'>
          <CoreInput
            control={control}
            name='code'
            label='Code'
            className='w-1/2 mb-5 px-3'
            disabled={showId !== null}
          />
          <CoreInput control={control} name='prefix' label='Prefix' className='w-1/2 mb-5 px-3' />
          <CoreInput control={control} name='name' label='Name' className='w-1/2 mb-5 px-3' />
          <div className='w-1/2 mb-5 px-3'>
            <Typography.Text className='w-full'>District</Typography.Text>
            <Controller
              control={control}
              name='district'
              render={({ field: { onChange, value }, fieldState: { error } }) => {
                const selectedDistrict = districtData?.find(
                  (item: { id: string; name: string }) => item.id === value,
                );
                const displayValue = selectedDistrict ? selectedDistrict.name : '';

                return (
                  <>
                    <Input
                      value={displayValue}
                      readOnly
                      placeholder='District cannot be changed, only cleared'
                      suffix={
                        value ? (
                          <CloseOutlined
                            onClick={() => onChange('')}
                            style={{ cursor: 'pointer', color: '#999' }}
                          />
                        ) : null
                      }
                      status={error ? 'error' : ''}
                      className='w-full'
                    />
                    {error && <p className='italic text-[#F5222D]'>{error.message}</p>}
                  </>
                );
              }}
            />
          </div>
          <CoreSelect
            control={control}
            optionsProps={cityData}
            showSearch
            onSearch={debounce((search: string) => searchCity(search), 500)}
            filterOption={false}
            name='city'
            label='City'
            displayField='name'
            valueField='id'
            className='w-1/2 mb-5 px-3'
            allowClear={false}
          />
        </div>
        <div className='text-right px-3 mt-3'>
          <Button type='primary' htmlType='submit' loading={isSubmitting} disabled={!isDirty}>
            Save
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};
